import { DeviceStatusInfo, Diagnostic, FaultData } from "@fairfleet/geotab";

interface Props {
  statusInfos: Record<string, DeviceStatusInfo>;
  faultData: FaultData[];
  diagnosticData: Record<string, Diagnostic>;
}

// Filters out faults that are not plausable
// For example, if a device saysis not plugged in, but gives data, we don't want to show that fault
export default function usePlausabilityCheckFaults(props: Props): FaultData[] {
  const { statusInfos, faultData } = props;
  const notPluggedInDiagnostic = "DiagnosticDeviceHasBeenUnpluggedId";
  return faultData.filter(fault => {
    const deviceStatusInfo = statusInfos[fault.device.id];

    if (!deviceStatusInfo) {
      return false;
    }
    if (fault.diagnostic.id === notPluggedInDiagnostic && deviceStatusInfo.isDeviceCommunicating) {
      return false;
    }

    return true;
  });
}
